/* eslint jsx-a11y/no-static-element-interactions:0 */
import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import classNames from 'classnames';

import Option from './Option';

const Category = ({ type, options, title, dispatch, expanded, toggleExpanded, isHidden }) => (
    options && !isHidden ? (
        <div
            className="cmn-filter__category"
            onClick={() => toggleExpanded(type)}
        >
            <div
                className={classNames(
                    'ui-accordion__header',
                    'cmn-filter__categoryRow',
                    { 'ui-accordion__header_active': expanded },
                )}
            >
                <span className="cmn-filter__categoryName">
                    {title}
                    <span className="cmn-filter__categorySelected">
                        {options.find(option => option.selected).label !== 'No filter' &&
                                options.find(option => option.selected).label}
                    </span>
                </span>
                <Svg
                    iconName="minus"
                    size="Medium"
                    className="accordionMinus ui-accordion__arrow tableShowIcon"
                />
                <Svg
                    iconName="plus"
                    size="Medium"
                    className="accordionPlus ui-accordion__arrow tableShowIcon"
                />
            </div>
            {expanded &&
                <ul>
                    {options.map(({ value, label, selected }) =>
                        <Option
                            key={label}
                            label={label}
                            selected={selected}
                            onClick={() => dispatch({ type, value, label })}
                        />
                    )}
                </ul>
            }
        </div>
    ) : null
);

const strOrNum = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
Category.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: strOrNum.isRequired,
        label: strOrNum.isRequired,
    })),
    expanded: PropTypes.bool,
    toggleExpanded: PropTypes.func,
    isHidden: PropTypes.bool,
};

export default Category;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/components/Category.jsx